// @ts-nocheck
import { catchAsync } from '../utils/api';
import axios from '../utils/axios';
import { EVENT_VIEWER, MARKET_GROUP_LABELS, MONITORING_API_ENDPOINT } from '../config';

const getAllTournamentTemplates = catchAsync(async params => {
    const result = await axios.get(`${EVENT_VIEWER}/tournaments`, { params });
    return result.data;
});

const getAllEventTemplates = catchAsync(async params => {
    const result = await axios.get(`${EVENT_VIEWER}/events`, { params });
    return result.data;
});

const getAllMarketTemplates = catchAsync(async params => {
    const result = await axios.get(`${EVENT_VIEWER}/markets`, { params });
    return result.data;
});

const getTournamentTemplate = catchAsync(async id => {
    const result = await axios.get(`${EVENT_VIEWER}/tournaments/${id}`);
    return result.data;
});

const getEventTemplate = catchAsync(async id => {
    const result = await axios.get(`${EVENT_VIEWER}/events/${id}`);
    return result.data;
});

const getMarketTemplate = catchAsync(async id => {
    const result = await axios.get(`${EVENT_VIEWER}/markets/${id}`);
    return result.data;
});

const createTournamentTemplate = catchAsync(async params => {
    const result = await axios.post(`${EVENT_VIEWER}/tournaments`, params);
    return result.data;
});

const createEventTemplate = catchAsync(async params => {
    const result = await axios.post(`${EVENT_VIEWER}/events`, params);
    return result.data;
});

const createEventTournamentTemplate = catchAsync(async params => {
    const result = await axios.post(`${MONITORING_API_ENDPOINT}/bets/event-viewer/template`, params);
    return result.data;
});

const createMarketTemplate = catchAsync(async params => {
    const result = await axios.post(`${EVENT_VIEWER}/markets`, params);
    return result.data;
});

const updateTournamentTemplate = catchAsync(async (id, params) => {
    const result = await axios.put(`${EVENT_VIEWER}/tournaments/${id}`, params);
    return result.data;
});

const updateEventTemplate = catchAsync(async (id, params) => {
    const result = await axios.put(`${EVENT_VIEWER}/events/${id}`, params);
    return result.data;
});

const updateMarketTemplate = catchAsync(async (id, params) => {
    const result = await axios.put(`${EVENT_VIEWER}/markets/${id}`, params);
    return result.data;
});

const deleteTournamentTemplate = catchAsync(async id => {
    const result = await axios.delete(`${EVENT_VIEWER}/tournaments/${id}`);
    return result.data;
});

const deleteEventTemplate = catchAsync(async id => {
    const result = await axios.delete(`${EVENT_VIEWER}/events/${id}`);
    return result.data;
});

const deleteMarketTemplate = catchAsync(async id => {
    const result = await axios.delete(`${EVENT_VIEWER}/markets/${id}`);
    return result.data;
});

const getSpecifiers = catchAsync(async params => {
    const result = await axios.get(`${MONITORING_API_ENDPOINT}/static-specifiers`, { params });

    return result.data;
});

const getMarketLabel = catchAsync(async id => {
    const result = await axios.get(`${MARKET_GROUP_LABELS}/market/${id}`);
    return result.data;
});

const deleteMarketLabel = catchAsync(async id => {
    const result = await axios.delete(`${MARKET_GROUP_LABELS}/market/${id}`);
    return result.data;
});

const RiskMonitoringService = {
    getAllTournamentTemplates,
    getTournamentTemplate,
    getEventTemplate,
    getMarketTemplate,
    createTournamentTemplate,
    createEventTemplate,
    createMarketTemplate,
    createEventTournamentTemplate,
    updateTournamentTemplate,
    updateEventTemplate,
    updateMarketTemplate,
    deleteTournamentTemplate,
    deleteEventTemplate,
    deleteMarketTemplate,
    getAllEventTemplates,
    getAllMarketTemplates,
    getSpecifiers,
    getMarketLabel,
    deleteMarketLabel,
};

export default RiskMonitoringService;
